import React, { useEffect, useState, useCallback } from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { BiSearch } from '@react-icons/all-files/bi/BiSearch';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import css from './index.module.scss';
import noImg from '../../assets/no-itm.png';
import FavoriteIcon from './images/favorites.png';
import { categoryNavigationGA } from 'spwa-ui-library/esm/utils/helperGA';
import CategoryMenuButton from '../../components/CategoryMenuButton';
import { useIntl, FormattedMessage } from 'react-intl';
import ClassNames from 'classnames';
import { useNavigate } from '@reach/router';
const { useSelector, useDispatch } = Redux;
const { clearProductState } = Slices.productSlice;
const {
  setSelectedCategoryID,
  setCurrentCat,
  selectAllMain,
  fetchCategoryStatus,
  currentCategory,
} = Slices.categorySlice;

const TabsContainer = ({
  // decoratedCategories,
  // index,
  // handleTabSelection,
  isDesktop,
  searchProducts,
  // tabIndex,
  searchState,
  handleSearch,
  categoryTags,
  selectedCategoryTag,
  handleCategoryTagSelection,
  setCategoryTags,
  categoryID,
  setCategories,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const categories = useSelector(selectAllMain);

  const navigatePage = (link) => {
    navigate(`/${intl.locale}${link}`);
  };
  const [tabIndex, setTabIndex] = useState(0);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const idx = getTabIndex(categoryID);
    setTabIndex((prev) => idx);
    setIndex((prev) => idx);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryID]);
  // useEffect(() => {
  //   if (categories?.length && !categories?.find((cat) => cat.id == categoryID)?.products?.length) {
  //     dispatch(
  //       fetchProductsByCategoryId({
  //         id: categoryID,
  //         cluster: clusterId,
  //         Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
  //       })
  //     );
  //   }
  // }, [intl.locale]);
  // const getCategoryIndex = useCallback(
  //   (id) => {
  //     return decoratedCategories.reduce(
  //       (acc, current, idx) => (current?.id?.toString() === id?.toString() ? idx : acc),
  //       -1
  //     );
  //   },
  //   [decoratedCategories]
  // );

  // const getTabIndex = useCallback(
  //   (id) => {
  //     let innerIndex = 0;
  //     let newArray = [];
  //     decoratedCategories.forEach((item) => {
  //       if (item.isHidden === 0 && !item?.parentId) {
  //         newArray.push(item);
  //       }
  //     });

  //     newArray.map((val, idx) => {
  //       if (val?.id?.toString() === id?.toString()) {
  //         innerIndex = idx;
  //       }
  //     });
  //     return innerIndex;
  //   },
  //   [decoratedCategories]
  // );
  // useEffect(() => {
  //   if (tagsState.status === 'succeeded') {
  //     const tagsData = Object.values(tagsState?.data || {}).sort(
  //       (tag1, tag2) => tag1.position - tag2.position
  //     );
  //     setCategoryTags(() => tagsData);
  //   }
  // }, [setCategoryTags, tagsState.data, tagsState.status]);
  // const handleTabSelection = (generatedPath, category) => () => {
  //   navigate(generatedPath);
  //   setUsedCategory(category.name);
  //   // categoryNavigationGA(category.name);
  //   dispatch(clearProductState());
  // };
  // useEffect(() => {
  //   favCheck ? setIndex(getCategoryIndex(categoryID)) : setIndex(0);
  //   favCheck ? setTabIndex(getTabIndex(categoryID)) : setIndex(0);
  //   dispatch(setSelectedCategoryID({ id: categoryID }));
  //   let categoryName = '';
  //   // swipeableViewsActions.updateHeight();
  //   const valueLocale = intl.locale;
  //   if (!isDecorated) {
  //     const result = categories.map((category, idx) => {
  //       const generatedPath = generateCategoryRoute({ category, valueLocale });
  //       if (category.id === Number(categoryID)) {
  //         categoryName = category.name;
  //       }

  //       return { ...category, generatedPath };
  //     });

  //     setUsedCategory(categoryName);

  //     // sort categories according to locale (asc for en and desc for ar)
  //     if (intl.locale == 'ar') {
  //       result.sort((obj1, obj2) => obj2?.position - obj1?.position);
  //     } else {
  //       result.sort((obj1, obj2) => obj1?.position - obj2?.position);
  //     }

  //     setCategories(result);
  //     markDecorated(true);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [
  //   categories,
  //   categoryID,
  //   isDecorated,
  //   getCategoryIndex,
  //   index,
  //   favCheck,
  //   dispatch,
  //   intl.locale,
  // ]);
  const handleTabSelection = (path, category) => {
    categoryNavigationGA(category?.name || '');
    const generatedPath = generateCategoryRoute({
      category: category,
      locale: intl.locale,
    });
    navigate(generatedPath);
  };
  const getTabIndex = useCallback(
    (id) => {
      let innerIndex = 0;
      let newArray = [];

      categories.forEach((item) => {
        if (item.isHidden === 0 && !item?.parentId) {
          newArray.push(item);
        }
      });

      newArray.map((val, idx) => {
        if (val?.id === +categoryID) {
          innerIndex = idx;
        }
      });
      return innerIndex;
    },
    [categories, categoryID]
  );
  return (
    <>
      <div className={css.navContainer}>
        <nav className={css.tabsContainer}>
          <CategoryMenuButton categories={categories} />
          <Tabs
            variant="scrollable"
            scrollButtons={isDesktop ? 'on' : 'off'}
            value={tabIndex}
            className={css.tabsBar + ' ' + (intl.locale == 'ar' ? css.reverse : '')}
          >
            {(intl.locale == 'en'
              ? categories
              : categories.sort((obj1, obj2) => obj2?.position - obj1?.position)
            ).map((category, idx) => {
              const activeTab = category.id === +categoryID;

              if (category.isHidden === 0 && !category?.parentId) {
                return (
                  <Tab
                    key={`Tab-${category.name}`}
                    label={
                      category.id === 999 ? (
                        <FormattedMessage id="profile_myfavorites" defaultMessage="Favorites" />
                      ) : (
                        category.name
                      )
                    }
                    icon={
                      <img
                        className={css.categoryTabIcon}
                        src={category.id === 999 ? FavoriteIcon : category?.assets[0]?.src}
                        alt={'Category'}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImg;
                        }}
                      />
                    }
                    className={ClassNames(css.tab, { active: activeTab })}
                    onClick={(ev) => handleTabSelection(category.generatedPath, category)}
                  ></Tab>
                );
              }
              return '';
            })}
          </Tabs>
          {isDesktop && (
            <div
              className={ClassNames(css.searchInput, { [css.active]: searchState })}
              onClick={() => {
                window.localStorage.removeItem(`searchText`);
                window.localStorage.removeItem(`searchQTag`);
                window.localStorage.setItem('beforeSearchLocation', window.location.pathname);
                navigatePage('/search');
              }}
            >
              <InputBase
                className={ClassNames(css.input, { [css.searchOpened]: searchState })}
                placeholder={intl.formatMessage({
                  id: 'category_search',
                  defaultMessage: 'Search',
                })}
                onChange={searchProducts}
                onClick={handleSearch}
              />
              <IconButton type="submit" className={css.iconButton} aria-label="search">
                <BiSearch />
              </IconButton>
            </div>
          )}
        </nav>
        {isDesktop && <Divider />}
      </div>
      {!isDesktop && (
        <div className={css.tagsContainer}>
          {categoryTags.map((category) => {
            let categoryName =
              category.tagName[intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1)];
            return (
              <Button
                variant={'outlined'}
                className={selectedCategoryTag === category.tagId ? css.selectedCategoryTag : ''}
                onClick={() => handleCategoryTagSelection(category.tagId)}
              >
                {' '}
                <img
                  src={
                    selectedCategoryTag === category.tagId
                      ? category.asset.selected
                      : category.asset.default
                  }
                  alt={categoryName}
                />{' '}
                {categoryName}
              </Button>
            );
          })}
        </div>
      )}
    </>
  );
};
export default TabsContainer;
